const getFormErrors = ({ name, touched, errors }) =>
  Object.keys(touched).includes(name) && errors[name];

export { getFormErrors };
